import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var NetworkConnectionService = /** @class */ (function () {
    function NetworkConnectionService(http) {
        this.http = http;
    }
    NetworkConnectionService.prototype.check = function () {
        return this.checkPage('').pipe(map(function (res) { return res.status === 200; }), catchError(function () { return throwError(false); }));
    };
    /**
     * Sirve para checkear  la conexión a internet.
     * @param url ruta para testear la conexión.
     */
    NetworkConnectionService.prototype.checkPage = function (url) {
        return this.http.get(url, { observe: 'response', responseType: 'text' });
    };
    NetworkConnectionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NetworkConnectionService_Factory() { return new NetworkConnectionService(i0.ɵɵinject(i1.HttpClient)); }, token: NetworkConnectionService, providedIn: "root" });
    return NetworkConnectionService;
}());
export { NetworkConnectionService };
